<template>
    <div>
        <NavbarOne/>

        <div class="flex items-center gap-4 flex-wrap bg-overlay p-14 sm:p-16 before:bg-title before:bg-opacity-70" :style="{backgroundImage:'url(' + bg + ')'}">
            <div class="text-center w-full">
                <h2 class="text-white text-8 md:text-[40px] font-normal leading-none text-center">Terms & Conditions</h2>
                <ul class="flex items-center justify-center gap-[10px] text-base md:text-lg leading-none font-normal text-white mt-3 md:mt-4">
                    <li><router-link to="/">Home</router-link></li>
                    <li>/</li>
                    <li class="text-primary">Terms & Conditions</li>
                </ul>
            </div>
        </div>

        <div class="s-py-100">
            <div class="container">
                <div class="max-w-[940px] mx-auto" data-aos="fade-up">
                    <p v-if="terms.updated_at" class="mb-6 text-sm opacity-70">Last updated: {{ terms.updated_at }}</p>
                    <article class="prose prose-h3:!text-3xl prose-h4:!text-2xl sm:prose-lg dark:prose-p:text-white-light dark:prose-li:text-white-light max-w-full prose-li:list-none prose-li:before:relative prose-li:before:content-[url('../img/icon/check.svg')] prose-ol:!pl-0 sm:prose-ol:!pl-0 prose-ul:pl-0 sm:prose-ul:pl-0 prose-li:flex prose-li:items-start prose-li:gap-2">
                        <!-- Clauses come from the admin (Website & App > Terms & Conditions).
                             fillTokens() swaps {phone} / {address} for the real details so the
                             number lives in one place. -->
                        <template v-for="(section, i) in terms.sections" :key="i">
                            <h3>{{ section.heading }}</h3>
                            <p v-for="(para, j) in paragraphs(fillTokens(section.body))" :key="j">{{ para }}</p>
                        </template>
                    </article>
                </div>
            </div>
        </div>

        <FooterOne/>

        <ScrollToTop/>

    </div>
</template>

<script setup>
    import { computed, onMounted } from 'vue';
    import { fillTokens, paragraphs, useSiteContent } from '@/lib/site-content';

    // Shares its request with the other pages; falls back to bundled copy if the
    // API is unreachable, so the page never renders an empty legal notice.
    const { content: siteContent } = useSiteContent();
    const terms = computed(() => siteContent.value.terms);

    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';

    import bg from '@/assets/img/shortcode/breadcumb.jpg'
    import Aos from 'aos';

    onMounted(()=>{
        Aos.init()
    })

</script>
